import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import style from "./offersHotspot.module.css";

// Import your images here
import bannerPic1 from "../assets/card 6.png";
import bannerPic2 from "../assets/card 5.png";

// Mock data for each offer category
const mockOffers = {
  allOffers: [
    { id: 1, img: bannerPic1, title: "All Offer 1" },
    { id: 2, img: bannerPic2, title: "All Offer 2" },
    { id: 3, img: bannerPic1, title: "All Offer 3" },
    { id: 4, img: bannerPic2, title: "All Offer 4" },
    { id: 5, img: bannerPic1, title: "All Offer 5" },
    { id: 6, img: bannerPic2, title: "All Offer 6" },
    { id: 7, img: bannerPic2, title: "All Offer 7" },
    { id: 8, img: bannerPic1, title: "All Offer 8"},
    { id: 9, img: bannerPic2, title: "All Offer 9" },
    { id: 10, img: bannerPic1, title: "All Offer 10" },
    { id: 11, img: bannerPic2, title: "All Offer 11" },
    // { id: 12, img: bannerPic1, title: "All Offer 12" },
    // Add more offers...
  ]
};

const OfferHotspot = () => {
  // const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('allOffers');
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 6;
  const [tours, setTours] = useState([]);
  const [error, setError] = useState(false);
  const [favorites, setFavorites] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const handleNavigate = (path) => {
    // navigate(path);
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setCurrentPage(0);
  };

  const totalPages = Math.ceil(mockOffers[activeCategory].length / itemsPerPage);

  const nextOffers = () => {
    setCurrentPage((prevPage) => (prevPage + 1) % totalPages);
  };

  const prevOffers = () => {
    setCurrentPage((prevPage) => (prevPage - 1 + totalPages) % totalPages);
  };

  const nextSlide = () => {
    
  };

  const prevSlide = () => {

  };

  const startIndex = currentPage * itemsPerPage;
  const visibleOffers = mockOffers[activeCategory].slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="container">
      <div className="text-start d-flex flex-column container align-items-baseline">
      <h3 style={{ color: "#321E5D",fontWeight:"800", }}>Offers <span style={{ color: "#680099" }}>Hotspots</span></h3>
      <p className="" style={{fontSize:"14px",fontWeight:500}}>Competitive Fares For Your Route-Specific Searches.</p>
      </div>

      <div>

              <div style={{ width: '100%',display: 'flex', justifyContent: 'space-between' ,flexDirection:'row'}}>
                  <div className="d-flex gap-2 mb-3 overflow-y-auto">
                  {['all', 'honeymoon', 'adventure', 'cultural', 'luxury'].map(category => (
                    <button key={category} className="rounded-pill ps-3 pe-3 pt-1 pb-2" 
                      style={{width:'120px',fontWeight:'700', border: "1px solid rgba(84, 28, 156, 1)", backgroundColor: selectedCategory === category ? '#541c9c' : 'white', color: selectedCategory === category ? 'white' : 'black'}}
                      onClick={() => handleCategoryClick(category)}>
                      {category.charAt(0).toUpperCase() + category.slice(1)}
                    </button>
                  ))}
                  </div>
        
                <div className="d-flex gap-2">
                  <div className="rounded-circle d-flex justify-content-center align-items-center bg-white" 
                    style={{ width: '40px', height: '40px', cursor: 'pointer', transition: 'transform 0.2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    onClick={prevSlide}>
                    <MdArrowBackIos size={24} />
                  </div>
                  <div className="rounded-circle d-flex justify-content-center align-items-center bg-white" 
                    style={{ width: '40px', height: '40px', cursor: 'pointer', transition: 'transform 0.2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    onClick={nextSlide}>
                    <MdArrowForwardIos size={24} />
                  </div>
                </div>
        
              </div>
      </div>

      <div
        className="container d-flex flex-row mb-5 flex-wrap gap-4"
        style={{ width: "100%" }}
      >
        <div className="row">
          {visibleOffers.map((offer) => (
            <div key={offer.id} className="col-12 col-sm-6 col-md-4 col-lg-4">
              <button className="border-0 w-100 mb-4" onClick={() => handleNavigate("/alloffers")}>
                <img
                  src={offer.img}
                  className={`rounded-2 ${style.cardHover}`}
                  alt={offer.title}
                  style={{ width: "100%", height: "auto" }}
                />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OfferHotspot;